import animateTo from './animateTo'


export default async function takeSnapShot(inSection, fitToSection = true) {
    return new Promise(async (resolve) => {
        
        
        const threeViewer = window.threeViewer
        const {renderer, scene, camera, controls} = threeViewer
        
        
        const snapshotSize = 1000
        
        const originalSize = {width: renderer.domElement.width, height: renderer.domElement.height};
        
        // Set the renderer to square
        

        await animateTo(inSection.sectionId, {
            duration: 0,
            fit: fitToSection,
            options : {
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0
            }
        }).then(async () => {
            await new Promise(resolve => setTimeout(resolve, 100))
            renderer.render(scene, camera);
            renderer.domElement.toBlob((blob) => {
                // Crop image to square
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const image = new Image();
                image.src = URL.createObjectURL(blob);
                image.onload = () => {
                    canvas.width = snapshotSize;
                    canvas.height = snapshotSize;
                    ctx.drawImage(image, (image.width - snapshotSize) / 2, (image.height - snapshotSize) / 2, snapshotSize, snapshotSize, 0, 0, snapshotSize, snapshotSize);
                    canvas.toBlob((blob) => {
                        resolve(blob)
                    }, 'image/png');
                }
                // resolve(blob)
            }, 'image/png');
        })
        
        
    });
}

function triggerCameraFlash() {
    const flashDiv = document.getElementById('flashEffect');
    flashDiv.style.display = 'block';
    flashDiv.style.opacity = '1';
    
    // Fade out the flash effect
    setTimeout(() => {
        flashDiv.style.opacity = '0';
    }, 200); // Adjust time as needed
    
    // Hide the div after the transition
    setTimeout(() => {
        flashDiv.style.display = 'none';
    }, 350); // This should match the CSS transition duration
}